/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { min2time, time2min } from '../../../../../helpers/utils';
import exportsFormulas from '../../../../CompanyExports/exportsFormulas';

export async function getrattrapage(columns, elearningAttempts, elearningTarget, elearningDuration, dataPdf, ponderation) {
  const result = dataPdf.userRattrapage;
  const finalData = [];
  if (!result) return ({});
  result.data.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
  result.data.forEach((element) => {
    // const quizPercent = parseInt(element.percent.toFixed(), 10);
    // const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
    // const timePercent = parseInt(element.time.toFixed(), 10);
    // let nbCriterias = 0;
    // let quizNote = (quizPercent === 100 ? 1 : (quizPercent / elearningTarget)) * 10;
    // let unitsNote = (unitsPercent === 100 ? 1 : (unitsPercent / elearningAttempts)) * 10;
    // let timeNote = timePercent >= elearningDuration ? 1 : (timePercent / elearningDuration) * 10;
    // if (elearningDuration && elearningDuration > 0) {
    //   nbCriterias += 1;
    // } else {
    //   timeNote = 0;
    // }
    // if (elearningTarget && elearningTarget > 0) {
    //   nbCriterias += 1;
    // } else {
    //   quizNote = 0;
    // }
    // if (elearningAttempts && elearningAttempts > 0) {
    //   nbCriterias += 1;
    // } else {
    //   unitsNote = 0;
    // }

    // let note = ((elearningTarget && elearningTarget > 0 ? quizNote : 0) + (elearningAttempts && elearningAttempts > 0 ? unitsNote : 0) + (elearningDuration && elearningDuration > 0 ? timeNote : 0)) / nbCriterias;
    // note *= 100;
    // note -= note % 1;
    // note /= 100;
    const { note } = exportsFormulas.rattrapageFormula(element, elearningTarget, elearningAttempts, elearningDuration);

    const rowData = [];
    rowData.push(`${element.name} ${element.firstname}`);
    rowData.push(`${element.percent.toFixed()}%`);
    rowData.push(`${element.unitsPercent.toFixed()}%`);
    rowData.push(min2time(element.time));
    rowData.push(note.toString());
    if (element.grade) {
      let examGradeArr = 0;
      let total = 0;
      if (element.catchUpGrade) {
        examGradeArr = Object.values(element.catchUpGrade);
        total = element.catchUpTotal;
      } else {
        examGradeArr = Object.values(element.grade);
        total = element.total;
      }
      const reduced = examGradeArr.reduce((sum, val) => sum + (val || 0), 0);
      const examGrade = ((reduced / total) * 20).toFixed(2);
      const gradePond = (((examGrade / 100) * ponderation.exams) + ((note / 100) * ponderation.elearning)).toFixed(2);
      rowData.push(examGrade);
      rowData.push(gradePond);
    } else {
      rowData.push('n/a');
      rowData.push('n/a');
    }
    finalData.push(rowData);
  });

  const content = {
    startY: 70,
    head: [columns],
    body: finalData,
    createdCell(cell) {
      if (cell.section === 'body') {
        if (cell.column.index === 2 && parseInt(cell.cell.raw.replace('%', ''), 10) < elearningTarget) {
          cell.cell.styles.fillColor = [216, 78, 75];
          cell.cell.styles.textColor = [255, 255, 255];
        } else if (cell.column.index === 4 && time2min(cell.cell.raw) < elearningDuration) {
          cell.cell.styles.fillColor = [216, 78, 75];
          cell.cell.styles.textColor = [255, 255, 255];
        } else if (cell.column.index === 3 && parseInt(cell.cell.raw.replace('%', ''), 10) < elearningAttempts) {
          cell.cell.styles.fillColor = [216, 78, 75];
          cell.cell.styles.textColor = [255, 255, 255];
        }
      }
    },

  };
  return content;
}

export async function getsuccess(columns, elearningTarget, elearningDuration, elearningAttempts, dataPdf, ponderation) {
  const result = dataPdf.userSuccess;
  const finalData = [];

  if (!result) return ({});
  result.data.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
  result.data.forEach((element) => {
    // const quizPercent = parseInt(element.percent.toFixed(), 10);
    // const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
    // const timePercent = parseInt(element.time.toFixed(), 10);
    // let nbCriterias = 0;
    // let quizNote = quizPercent === 100 ? 10 : quizPercent / 10;
    // let unitsNote = unitsPercent === 100 ? 10 : unitsPercent / 10;
    // let timeNote = timePercent >= elearningDuration ? 10 : (timePercent / elearningDuration) * 10;
    // if (elearningDuration && elearningDuration > 0) {
    //   nbCriterias += 1;
    // } else {
    //   timeNote = 0;
    // }
    // if (elearningTarget && elearningTarget > 0) {
    //   nbCriterias += 1;
    // } else {
    //   quizNote = 0;
    // }
    // if (elearningAttempts && elearningAttempts > 0) {
    //   nbCriterias += 1;
    // } else {
    //   unitsNote = 0;
    // }

    // let note = ((quizNote + unitsNote + timeNote) / nbCriterias) + 10;
    // note *= 100;
    // note -= note % 1;
    // note /= 100;

    const { note } = exportsFormulas.successFormula(element, elearningTarget, elearningAttempts, elearningDuration);

    const rowData = [];
    rowData.push(`${element.name} ${element.firstname}`);
    rowData.push(`${element.percent.toFixed()}%`);
    rowData.push(`${element.unitsPercent.toFixed()}%`);
    rowData.push(min2time(element.time));
    rowData.push(note.toString());
    if (element.grade) {
      let examGradeArr = 0;
      let total = 0;
      if (element.catchUpGrade) {
        examGradeArr = Object.values(element.catchUpGrade);
        total = element.catchUpTotal;
      } else {
        examGradeArr = Object.values(element.grade);
        total = element.total;
      }
      const reduced = examGradeArr.reduce((sum, val) => sum + (val || 0), 0);
      const examGrade = ((reduced / total) * 20).toFixed(2);
      const gradePond = (((examGrade / 100) * ponderation.exams) + ((note / 100) * ponderation.elearning)).toFixed(2);
      rowData.push(examGrade);
      rowData.push(gradePond);
    } else {
      rowData.push('n/a');
      rowData.push('n/a');
    }
    finalData.push(rowData);
  });

  const content = {
    startY: 115,
    head: [columns],
    body: finalData,
    createdCell(cell) {
      if (cell.section === 'head') {
        cell.cell.styles.fillColor = [78, 216, 75];
        cell.cell.styles.textColor = [255, 255, 255];
      }
    },
  };
  return content;
}

export async function getnotrack(columns, dataPdf, ponderation) {
  const result = dataPdf.userNoTrackers;
  const columnsName = [];
  if (!result) return ({});
  for (let i = 0; i < 2; i += 1) {
    columnsName.push(columns[i]);
  }

  const finalData = [];

  result.data.forEach((element) => {
    const rowData = [];
    rowData.push(`${element.name} ${element.firstname}`);
    rowData.push('Jamais connecté(e)');
    rowData.push('Jamais connecté(e)');
    rowData.push('Jamais connecté(e)');
    rowData.push('0');

    if (element?.grade) {
      let examGradeArr = 0;
      let total = 0;
      if (element?.catchUpGrade) {
        examGradeArr = Object.values(element.catchUpGrade);
        total = element.catchUpTotal;
      } else {
        examGradeArr = Object.values(element.grade);
        total = element.total;
      }
      const reduced = examGradeArr.reduce((sum, val) => sum + (val || 0), 0);
      const examGrade = ((reduced / total) * 20).toFixed(2);
      const gradePond = (((examGrade / 100) * ponderation.exams) + ((0 / 100) * ponderation.elearning)).toFixed(2);
      rowData.push(examGrade);
      rowData.push(gradePond);
    } else {
      rowData.push('0');
      rowData.push('0');
    }

    finalData.push(rowData);
  });

  const content = {
    startY: 70,
    head: [columnsName],
    body: finalData,
    createdCell(cell) {
      if (cell.section === 'head') {
        cell.cell.styles.fillColor = [216, 78, 75];
        cell.cell.styles.textColor = [255, 255, 255];
      }
    },
  };
  return content;
}
